import api from '@/shared/api/api-client';

import { EXPORT_FORMAT_CONFIG } from '../domain/export-plan.model';
import type { ProfileExportGateway } from './profile-export.gateway';

/**
 * Real implementation over the shared api client. XLSX is binary and comes
 * back as a Blob directly; CSV/JSON come back as text and are wrapped into a
 * Blob with the right MIME type (kept 1:1 with the original useProfileExport).
 */
export const httpProfileExportGateway: ProfileExportGateway = {
  exportBlob: async (request) => {
    if (request.format === 'xlsx') {
      return api.postBlob('/profiles/export', request);
    }
    const text = await api.postText('/profiles/export', request);
    return new Blob([text], { type: EXPORT_FORMAT_CONFIG[request.format].mime });
  },
};
